import { NormalizedCacheObject } from 'apollo-boost';
import ApolloClient from 'apollo-client/ApolloClient';
import moment from 'moment';

import { logQuery } from '../../graphql/queries/log/log';
import { mapLogFilterToApiFormat } from '../../mappers/log/filters';
import { LogHelpers } from '../../service/LogHelpers/LogHelpers';
import { FilterPartialExpression } from '../../typings/filter';
import { userActionLogContextQuery } from '../../typings/graphql-log';
import { SortDirection } from '../../typings/grid';
import { defaultLogRowsCount, LogPeriod, LogsOrder } from '../../typings/log';

export class LogDataSource {
    constructor(private readonly client: ApolloClient<NormalizedCacheObject>) {}

    public requestData(
        filter: FilterPartialExpression[] = [],
        period: LogPeriod,
        order: SortDirection = SortDirection.asc,
        clientLogin?: string,
        pageToken?: string | null
    ): Promise<userActionLogContextQuery> {
        const filters = mapLogFilterToApiFormat(filter) || {},
            date = this.parsePeriods(period),
            token = pageToken === undefined ? null : pageToken,
            limit = defaultLogRowsCount,
            parsedOrder = this.getOrder(order);

        return this.client
            .query<userActionLogContextQuery>({
                query: logQuery,
                // отключаем кеширование запросов, так как при выполнении массовых действий над элементами таблицы
                // нужна перезагрузка данных с сервера
                fetchPolicy: 'no-cache',
                variables: {
                    clientLogin,
                    limit,
                    order: parsedOrder,
                    token,
                    ...date,
                    ...filters
                }
            })
            .then(response => response.data);
    }

    private parsePeriods(period: LogPeriod): { dateFrom: string; dateTo: string } | {} {
        const now = moment();

        return LogHelpers.getUserLogPeriods(period, now);
    }

    private getOrder(order: SortDirection): LogsOrder {
        return order === SortDirection.asc ? LogsOrder.asc : LogsOrder.desc;
    }
}
